<template>
    <v-dialog
        v-model="$store.state.credential.dialog"
        scrollable
        persistent
        max-width="600px"
        transition="dialog-transition"
    >
        <v-card>
            <v-toolbar color="secondary" dense dark>
                <v-spacer></v-spacer>
                <v-card-title primary-title> Add Credentials </v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.credential.dialog = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container fluid>
                <v-card-text>
                    <v-form ref="form" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-combobox
                                        v-model="crendetial"
                                        :items="crendetials"
                                        :item-text="'CredType'"
                                        :item-value="'CredTypeID'"
                                        label="Select Credentials Type"
                                        auto-select-first
                                        :rules="[
                                            v =>
                                                !!v ||
                                                'Credential Type is required'
                                        ]"
                                        required
                                    ></v-combobox>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Number"
                                        v-model="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        id="CredExpiry"
                                        label="CredExpiry"
                                        :value="CredExpiry"
                                        :placeholder="$store.state.placeholder"
                                        v-mask="$store.state.mask"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="end">
                                <v-btn
                                    small
                                    @click="validate()"
                                    color="secondary"
                                    >Save</v-btn
                                >
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    props: ['drvID'],
    directives: {
        mask
    },
    data: function() {
        return {
            crendetials: [],
            crendetial: '',
            CredExpiry: '',
            number: '',
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ]
        };
    },
    mounted() {
        this.loadComboBoxType();
    },
    methods: {
        newCrendetial: function() {
            var str = this.$store;
            var parms = {
                CredTypeID: this.crendetial.CredTypeID,
                CredNumber: this.number,
                DriverId: this.drvID,
                CredExpiry: this.$store.state.getMsk('CredExpiry')
            };
            if (this.crendetial.CredTypeID == null) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Select a credential type'
                });
            } else {
                str.state.isLoading = true;
                axios
                    .post('credential', parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response);
                        str.state.isLoading = false;
                        this.$store.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'crendential saved successfully'
                        });
                        this.$store.state.BadgeCred.watch = true;
                        this.$store.state.credential.dialog = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.state.isLoading = false;
                    });
            }
        },
        loadComboBoxType: function() {
            axios
                .get('credential-types')
                .then(response => {
                    this.crendetials = response.data;
                    console.log(this.crendetials);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.newCrendetial();
            }
        }
    }
};
</script>

<style></style>
